import { FETCH_INSURANCE_PLAN, FETCH_INSURANCE_PLANS } from '../actions/types';
import { normalize } from './index';

const initialState = {
    all: {}
};

export default function(state = initialState, action) {
    switch(action.type) {
        case `${FETCH_INSURANCE_PLANS}_FULFILLED`:
            return {
                ...state,
                all: {
                    ...state.all,
                    ...normalize(action.payload.data)
                }
            };
        case `${FETCH_INSURANCE_PLAN}_FULFILLED`:
            return {
                ...state,
                all: {
                    ...state.all,
                    [action.payload.data.id]: action.payload.data
                }
            };
        default:
            return state;
    }
}
